import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-tratamiento-datos',
  templateUrl: './modal-tratamiento-datos.component.html',
  styleUrls: ['./modal-tratamiento-datos.component.scss']
})
export class ModalTratamientoDatosComponent implements OnInit {

  @Input() isVisible: boolean = false;
  @Output() onClose = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  cerrarModal(): void {
    this.isVisible = false;
    this.onClose.emit(false);
  }

}
